import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=4e4bea60&scoped=true&"
import script from "./Comparison.vue?vue&type=script&lang=ts&"
export * from "./Comparison.vue?vue&type=script&lang=ts&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=4e4bea60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4bea60",
  null
  
)

export default component.exports